document.addEventListener('DOMContentLoaded', function () {
  console.log('Variant description script loaded (DOMContentLoaded)');

  const productDescriptionElement = document.querySelector('.rte.text--pull');
  const variantDescriptions = JSON.parse(document.getElementById('variantDescriptions').textContent);
  const variantInputs = document.querySelectorAll('input[name="id"]');

  function updateDescription(variantId) {
    if (variantDescriptions[variantId]) {
      console.log('Updated description for variant:', variantId);
      productDescriptionElement.innerHTML = variantDescriptions[variantId];
    } else {
      console.log('No description for variant:', variantId);
    }
  }

  // Listen to variant input changes (radio swatches)
  variantInputs.forEach(input => {
    input.addEventListener('change', function () {
      updateDescription(this.value);
    });
  });

  // Set initial description
  const selected = document.querySelector('input[name="id"]:checked');
  if (selected) {
    updateDescription(selected.value);
  }
});
